<template>
  <div class="container">
    <div class="wrapper">
      <Header v-if="!isIframe"/>
      <Main/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Main from '@/components/layout/Main'
import Footer from '@/components/layout/Footer'

export default {
    name: 'I18nView',
    components: {
        Header,
        Main,
        Footer
    },
    computed: {
        isIframe: function() {
            return this.$store.state.app.entrypoint === 'iframe'
        }
    }
}
</script>
